import { create } from 'zustand';
import type { Session } from '@supabase/supabase-js';

export type AuthStatus = 'unknown' | 'anonymous' | 'authenticated';

interface AuthState {
  session: Session | null;
  hydrated: boolean;
  setSession: (s: Session | null) => void;
  markHydrated: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  session: null,
  hydrated: false,
  setSession: (s) => set({ session: s, hydrated: true }),
  markHydrated: () => set({ hydrated: true }),
}));

export const selectStatus = (s: { session: Session | null; hydrated: boolean }): AuthStatus =>
  !s.hydrated ? 'unknown' : s.session ? 'authenticated' : 'anonymous';
